import axios from 'axios';
import i18n from 'i18next';

import { addToast, handleAxiosError } from 'core/notifications';

const untransformLearnerData = (data) =>
  data.accessible_by.map((item) => ({
    avatar_path: item.avatar,
    code: item.code,
    metadata: {
      number_of_members: item.membersCount,
    },
    id: item.id,
    name: item.name,
    type: item.type,
  }));

const untransformEditorData = (data) =>
  data.accessible_by.map((item) => ({
    avatar: item.avatar_path,
    code: item.code,
    metadata: {
      number_of_eligible_members: item.eligibleMembers,
      jobTitle: item.jobTitle || null,
    },
    id: item.id,
    name: item.name,
    type: item.type,
  }));

export default async ({ modifiedModel, module, params, videoVersion }) => {
  let data = modifiedModel;
  const itemId = params.id;
  const isInLiveMode = params.type === 'live';
  const permissionableType = isInLiveMode ? 'Course' : 'ContentListItem';

  if (module === 'learner') {
    const permissionableId = isInLiveMode ? videoVersion.data.video_id : itemId;
    data = {
      access_type: data.access_type,
      id: Number(itemId),
      permissionable_id: Number(permissionableId),
      permissionable_type: permissionableType,
      accessible_by: untransformLearnerData(data),
    };
  } else {
    data = {
      permissionable_id: Number(itemId),
      permissionable_type: permissionableType,
      accessible_by: untransformEditorData(data),
    };
  }

  const url = module === 'learner' ? '/api/admin/permissions' : '/api/admin/admin_permissions';

  try {
    await axios.post(url, {
      data,
    });
    await addToast(i18n.t('permissions-saved-successfully'));
  } catch (error) {
    await handleAxiosError(error);
  }
};
